import $ from 'jquery';
import UIkit from 'uikit';

$(document).ready(function($) {
    $('.js-product-open').click(function(){
        const item = $(this).data('product-item');
        UIkit.slider('.js-product-slider').show(item);
    });
});